import { render, staticRenderFns } from "./_banner.vue?vue&type=template&id=72454ade"
import script from "./_banner.vue?vue&type=script&lang=js"
export * from "./_banner.vue?vue&type=script&lang=js"
import style0 from "./_banner.vue?vue&type=style&index=0&id=72454ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports